import { format, parse, differenceInCalendarDays } from 'date-fns'
import { DateKey } from '../types/DateKey'

export const MS = {
  DAY: 1000 * 60 * 60 * 24,
  HOUR: 1000 * 60 * 60,
  MINUTE: 1000 * 60,
  SECOND: 1000,
}

export const UPDATE_HOUR = 11
export const UPDATE_MINUTE = 0

export const toDate = (dateKey: DateKey) => {
  return parse(dateKey, 'yyyy-MM-dd', new Date())
}

export const isUpdatedAtToday = () => {
  const now = new Date()
  return now.getHours() >= UPDATE_HOUR && now.getMinutes() >= UPDATE_MINUTE
}

export const getCurrentYear = () => new Date().getFullYear()

export const getCurrentMonth = () => new Date().getMonth() + 1

export const getDateKeyBeforeNDays = (nDays = 0): DateKey => {
  const date = new Date(Date.now() - nDays * MS.DAY)
  return formatDate(date, 'yyyy-MM-dd') as DateKey
}

export const getTodayKey = (): DateKey => {
  return getDateKeyBeforeNDays(0)
}

export const getDateKeysRecentNDays = (nDays: number) => {
  return new Array(nDays)
    .fill(0)
    .map((_, i) => new Date(Date.now() - (nDays - 1 - i) * MS.DAY))
    .map((date) => formatDate(date, 'yyyy-MM-dd') as DateKey)
}

export const getDiffDays = (dateA: Date, dateB: Date) => {
  return Math.abs(differenceInCalendarDays(dateA, dateB))
}

export const formatDate = (targetDate: Date | number, type = 'PPP') => {
  return format(targetDate, type)
}

export const toDayName = (day: number) => {
  switch (day) {
    case 0:
      return '일'
    case 1:
      return '월'
    case 2:
      return '화'
    case 3:
      return '수'
    case 4:
      return '목'
    case 5:
      return '금'
    case 6:
    default:
      return '토'
  }
}

const toUpdateTime = (date: Date) => {
  const newDate = new Date(date.getTime())
  newDate.setHours(UPDATE_HOUR)
  newDate.setMinutes(UPDATE_MINUTE)
  newDate.setSeconds(0)
  newDate.setMilliseconds(0)

  return newDate.getTime()
}

export const restTimeToNextUpdate = () => {
  const now = Date.now()
  const nextUpdateTime = isUpdatedAtToday()
    ? toUpdateTime(new Date(now + MS.DAY))
    : toUpdateTime(new Date())

  return nextUpdateTime - now
}

export const parseTime = (time: number) => {
  return {
    hours: Math.floor(time / MS.HOUR),
    minutes: Math.floor((time % MS.HOUR) / MS.MINUTE),
    seconds: Math.floor((time % MS.MINUTE) / MS.SECOND),
  }
}
